
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabhireinbhosarimidc() {



    const cardData =
    {
        keyword: 'Cab Hire in Bhosari MIDC Area',
        heading: 'Platinum24 Cabs: Cab Hire in Bhosari MIDC Area',
        headingDescription: ' Platinum24 Cabs provides dependable Cab Hire in Bhosari MIDC Area, catering to professionals, industrial visitors, and local residents in Pune’s major manufacturing hub. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures safe, comfortable, and affordable travel for daily commutes, client transfers, and outstation trips. With professional chauffeurs, punctual pickups, and transparent fares, we make travel across Bhosari MIDC stress-free and reliable. Whether you need a corporate cab for factory visits, an airport transfer, or a one-day trip, Platinum24 Cabs guarantees 24/7 availability and trustworthy cab hire services in Bhosari MIDC.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. It was once the seat of the Maratha Empire and still echoes the legacy of Bajirao and Mastani. Its mighty Delhi Gate, fountains, and expansive gardens attract thousands of visitors. Though destroyed by fire in 1828, the ruins still retain grandeur. The evening light-and-sound show recreates Maratha history. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a majestic monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum displaying Gandhi’s personal belongings and photographs. Its sprawling lawns and Italian arches add to the charm. It is also the resting place of Kasturba Gandhi. Aga Khan Palace is Pune’s historical gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. The fort sits atop a hill offering trekking trails and panoramic Sahyadri views. Visitors explore its bastions, memorials, and temples reflecting Maratha valor. Monsoon adds mist, waterfalls, and greenery. Local villagers serve rustic pithla-bhakri meals. Sinhagad is Pune’s perfect mix of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, adorned with gold and ornaments, attracts lakhs of devotees annually. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also known for charitable and cultural activities. The spiritual aura here draws devotees and tourists alike. Dagdusheth Ganpati is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The site features a sanctum, massive stone pillars, and a Nandi mandapa. Despite being in the city’s center, it offers peace and a spiritual retreat. Evening chants enhance the mystical ambiance. Its carvings showcase early Indian rock-cut craftsmanship. Pataleshwar is Pune’s hidden heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure trove with over 20,000 artifacts collected by Dr. Dinkar Kelkar. The collection includes ornaments, sculptures, musical instruments, and antiques of daily life. The recreated Mastani Mahal is the highlight for visitors. Students and history enthusiasts find it fascinating and educational. It preserves centuries of cultural heritage. The museum is Pune’s proud showcase of art and tradition."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop houses the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the shrine, blending devotion with adventure. Smaller shrines and a museum add cultural depth. Sunrises and sunsets from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of wellness and spirituality. Spread across serene gardens, it offers meditation, yoga, and personal growth workshops. Zen-inspired landscapes and modern facilities attract seekers worldwide. Visitors experience rejuvenation, peace, and mindfulness here. It is a unique blend of spirituality and modern lifestyle. Osho Ashram is Pune’s international retreat of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, modeled after Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and manicured lawns. Families and couples enjoy peaceful walks, picnics, and photography here. Seasonal flowers add charm throughout the year. The garden reflects Indo-Japanese cultural ties. Pu La Deshpande Garden is Pune’s lush green paradise."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. It supplies water to the city while offering scenic landscapes. Monsoon turns it into a picturesque spot with overflowing waters. Vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],


          "services": [
    {
      "name": "Bhosari MIDC Cab Hire",
      "description": "Hire cabs in Bhosari MIDC with ease and convenience. Our Bhosari MIDC Cab Hire service is perfect for daily travel, business use, or commuting to nearby areas. We offer a fleet of clean, well-maintained vehicles with trained drivers to ensure a smooth and reliable journey every time."
    },
    {
      "name": "Taxi Service Bhosari MIDC",
      "description": "Our Taxi Service in Bhosari MIDC offers prompt pickups, professional drivers, and comfortable rides at any time of the day. Whether you're heading to work, an industrial meeting, or need a local ride, our service is tailored for efficiency and convenience."
    },
    {
      "name": "Cab Rental Bhosari MIDC",
      "description": "Choose from a variety of cars with our flexible Cab Rental service in Bhosari MIDC. Rent by the hour, day, or for custom durations. Ideal for professionals, executives, and industrial visitors looking for dependable ground transportation."
    },
    {
      "name": "Bhosari MIDC Local Taxi",
      "description": "Need a taxi for short distances in Bhosari MIDC? Our local taxi service is affordable and available 24/7. We cover all industrial zones, residential areas, and connecting roads for your local commuting needs."
    },
    {
      "name": "Affordable Taxi Bhosari MIDC",
      "description": "Get budget-friendly taxi service in Bhosari MIDC without compromising on comfort or quality. Our competitive rates are perfect for daily travel, ensuring a pocket-friendly commute every time."
    },
    {
      "name": "Bhosari MIDC Taxi with Driver",
      "description": "Book taxis in Bhosari MIDC with experienced and verified drivers. Our drivers are well-versed with the industrial and residential layouts of the region, offering a stress-free travel experience."
    },
    {
      "name": "Bhosari MIDC Airport Taxi",
      "description": "Fast and reliable airport transfers from Bhosari MIDC to Pune Airport. Our airport taxi service ensures timely pickup and drop-offs, with real-time flight tracking and 24/7 availability."
    },
    {
      "name": "Cab Service Near Me Bhosari MIDC",
      "description": "Looking for a cab near Bhosari MIDC? Our wide network allows us to dispatch taxis promptly from the closest location. Expect short wait times and fast service wherever you are in Bhosari."
    },
    {
      "name": "Bhosari MIDC Outstation Taxi",
      "description": "Travel beyond Pune with our Bhosari MIDC Outstation Taxi service. Whether it's for business, factory visits, or personal trips, we offer one-way and round-trip packages to cities across Maharashtra."
    },
    {
      "name": "Bhosari MIDC Corporate Taxi",
      "description": "Specialized taxi services for corporate clients in Bhosari MIDC. Enjoy invoicing, priority bookings, and executive vehicles ideal for business meetings, factory visits, and airport transfers."
    },
    {
      "name": "Bhosari MIDC Taxi Deals",
      "description": "Get the best value for money with our ongoing taxi deals in Bhosari MIDC. Enjoy discounted fares, promotional packages, and exclusive offers on frequent bookings and subscriptions."
    },
    {
      "name": "Bhosari MIDC City Taxi",
      "description": "Navigate Bhosari MIDC and Pune city effortlessly with our city taxi service. Whether it's office visits, errands, or shopping trips, we provide fast and convenient rides around the clock."
    },
    {
      "name": "Bhosari MIDC Family Taxi Service",
      "description": "Travel with comfort and safety with our Family Taxi Service in Bhosari MIDC. Spacious vehicles and friendly drivers make this the perfect choice for group outings, school runs, or family functions."
    },
    {
      "name": "Taxi Booking Online Bhosari MIDC",
      "description": "Book your taxi online from Bhosari MIDC in just a few clicks. Our digital platform allows for instant confirmations, secure payments, and hassle-free scheduling of your trips."
    },
    {
      "name": "Bhosari MIDC Taxi Service 24x7",
      "description": "No matter the time, our 24x7 taxi service in Bhosari MIDC is always available. Ideal for shift workers, early morning airport transfers, or late-night returns from work or travel."
    }
  ],
  "tableData": [
    ["Bhosari MIDC Cab Hire", "Taxi Service Bhosari MIDC"],
    ["Cab Rental Bhosari MIDC", "Bhosari MIDC Local Taxi"],
    ["Affordable Taxi Bhosari MIDC", "Bhosari MIDC Taxi with Driver"],
    ["Bhosari MIDC Airport Taxi", "Cab Service Near Me Bhosari MIDC"],
    ["Bhosari MIDC Outstation Taxi", "Bhosari MIDC Corporate Taxi"],
    ["Bhosari MIDC Taxi Deals", "Bhosari MIDC City Taxi"],
    ["Bhosari MIDC Family Taxi Service", "Taxi Booking Online Bhosari MIDC"],
    ["Bhosari MIDC Taxi Service 24x7", "—"]
  ],


       "whychoose": [
    {
      "WhyChooseheading": "Trusted Cab Hire Service in Bhosari MIDC Area",
      "WhyChoosedescription": "Platinum24 Cabs provides reliable and timely cab hire services across the Bhosari MIDC area for all your travel requirements."
    },
    {
      "WhyChooseheading": "Quick and Convenient Pickup",
      "WhyChoosedescription": "Our drivers are always nearby in Bhosari MIDC to ensure prompt pickups and smooth rides."
    },
    {
      "WhyChooseheading": "Clean and Comfortable Vehicles",
      "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs designed for your comfort and safety."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with Industrial Area Routes",
      "WhyChoosedescription": "Our professional drivers know the Bhosari MIDC area well to provide efficient and timely rides."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "Enjoy upfront pricing with no hidden fees, covering fuel, tolls, and driver allowances."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
      "WhyChoosedescription": "Our support team is available round the clock to assist with bookings and travel inquiries."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for Local and Outstation Travel",
      "WhyChoosedescription": "Choose from hourly rentals, point-to-point rides, or long-distance journeys as per your needs."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options to Suit Your Group Size",
      "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or tempo travellers depending on your comfort and luggage preferences."
    }
  ]




























    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer cab hire services in Bhosari MIDC area?',
        answer: 'Yes, Platinum24 Cabs provides reliable and convenient cab hire services in the Bhosari MIDC area for both local and outstation travel.',
    },
    {
        question: 'How can I book a cab hire in Bhosari MIDC with Platinum24 Cabs?',
        answer: 'You can easily book your cab through our website, mobile app, or by contacting our 24x7 customer support team.',
    },
    {
        question: 'What types of vehicles are available for cab hire in Bhosari MIDC?',
        answer: 'We offer a variety of vehicles including hatchbacks, sedans, SUVs, and premium cars to suit your travel requirements.',
    },
    {
        question: 'Can I hire cabs for local travel as well as outstation trips from Bhosari MIDC?',
        answer: 'Yes, Platinum24 Cabs provides both local and outstation cab hire services from Bhosari MIDC to various destinations.',
    },
    {
        question: 'Are your drivers experienced and familiar with Bhosari MIDC routes?',
        answer: 'Absolutely. Our drivers are professional, licensed, and well-acquainted with Bhosari MIDC and surrounding areas to ensure safe travel.',
    },
    {
        question: 'Is hourly cab hire available in Bhosari MIDC area?',
        answer: 'Yes, we offer hourly rental packages for flexible cab hire options in Bhosari MIDC.',
    },
    {
        question: 'Are safety and hygiene protocols followed for cab hire services in Bhosari MIDC?',
        answer: 'All vehicles are sanitized regularly, and drivers follow strict safety measures to protect passengers.',
    },
    {
        question: 'Is cab hire service in Bhosari MIDC available 24x7?',
        answer: 'Yes, Platinum24 Cabs offers 24x7 cab hire booking and services in the Bhosari MIDC area.',
    },
    {
        question: 'What payment options are accepted for cab hire bookings in Bhosari MIDC?',
        answer: 'We accept cash, digital wallets, UPI, and card payments for smooth transactions.',
    },
    {
        question: 'Can I customize pickup and drop-off locations within Bhosari MIDC area?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points within Bhosari MIDC as per your travel plans.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ramesh Patil',
        feedback: 'The cab hire service in Bhosari MIDC by Platinum24 Cabs was prompt and comfortable. Highly recommended!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Kavita Deshmukh',
        feedback: 'Smooth booking experience and excellent service for cab hire in Bhosari MIDC.',
        rating: 5,
    },
];


































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];









const bhosariMidcCabHireSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Reliable and affordable cab hire service in Bhosari MIDC area, offering local, outstation, airport taxi, and corporate taxi services with driver available 24x7.",
  "areaServed": {
    "@type": "Place",
    "name": "Bhosari MIDC"
  },
  "serviceType": [
    "Bhosari MIDC Cab Hire",
    "Taxi Service Bhosari MIDC",
    "Cab Rental Bhosari MIDC",
    "Bhosari MIDC Local Taxi",
    "Affordable Taxi Bhosari MIDC",
    "Bhosari MIDC Taxi with Driver",
    "Bhosari MIDC Airport Taxi",
    "Cab Service Near Me Bhosari MIDC",
    "Bhosari MIDC Outstation Taxi",
    "Bhosari MIDC Corporate Taxi",
    "Bhosari MIDC Taxi Deals",
    "Bhosari MIDC City Taxi",
    "Bhosari MIDC Family Taxi Service",
    "Taxi Booking Online Bhosari MIDC",
    "Bhosari MIDC Taxi Service 24x7"
  ],
  "telephone": "+91-XXXXXXXXXX"
};




    return (
        <div>

<Helmet>
  <title>Cab Hire in Bhosari MIDC Area | Affordable Taxi Service</title>
  <meta
    name="description"
    content="Reliable and affordable cab hire service in Bhosari MIDC area, offering local, outstation, airport taxi, and corporate taxi services with driver available 24x7."
  />
  <meta
    name="keywords"
    content="Bhosari MIDC Cab Hire, Taxi Service Bhosari MIDC, Cab Rental Bhosari MIDC, Bhosari MIDC Local Taxi, Affordable Taxi Bhosari MIDC, Bhosari MIDC Taxi with Driver, Bhosari MIDC Airport Taxi, Cab Service Near Me Bhosari MIDC, Bhosari MIDC Outstation Taxi, Bhosari MIDC Corporate Taxi, Bhosari MIDC Taxi Deals, Bhosari MIDC City Taxi, Bhosari MIDC Family Taxi Service, Taxi Booking Online Bhosari MIDC, Bhosari MIDC Taxi Service 24x7"
  />
  <script type="application/ld+json">
    {JSON.stringify(bhosariMidcCabHireSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/78.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabhireinbhosarimidc;